import ProductsSlider from 'components/Blocks/Product/ProductsSlider';
import { ProductRecommendationAreaType } from 'types/productRecommendationArea';

export type ProductRecommendationAreaProps = {
    productSliderClassName?: string;
    productRecommendationArea: ProductRecommendationAreaType;
    fallbackGtmId: string;
    maxVisibleItems?: number;
    onAddToCart?: (productUuid: string) => void;
};

export const ProductRecommendationArea: FC<ProductRecommendationAreaProps> = ({
    productSliderClassName,
    productRecommendationArea,
    fallbackGtmId,
    maxVisibleItems,
    onAddToCart,
}) => {
    const gtmAreaName = productRecommendationArea.area.gtmId
        ? productRecommendationArea.area.gtmId
        : `${fallbackGtmId} ${productRecommendationArea.area.header}`;

    if (productRecommendationArea.area.externalSourceDivId) {
        return <div id={productRecommendationArea.area.externalSourceDivId} />;
    }

    if (productRecommendationArea.products.length === 0) {
        return null;
    }

    return (
        <div>
            <h3 className="mb-0 lg:mb-0">{productRecommendationArea.area.header}</h3>
            <ProductsSlider
                noMarginBottom
                className={productSliderClassName}
                gtmListName={gtmAreaName}
                maxVisibleItems={maxVisibleItems}
                products={productRecommendationArea.products}
                onAddToCart={onAddToCart}
            />
        </div>
    );
};
